import React, { useState } from "react"
import { FormattedMessage, defineMessages, injectIntl } from "react-intl"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import IntlProps from "../state/helpers/IntlProps"
import PasswordInput from "../user/form/PasswordInput"
import { Button, Form, Modal } from "react-bootstrap"

const messages = defineMessages({
    "user.form.edit.current_password_placeholder": {
        id: "user.form.edit.current_password_placeholder",
        defaultMessage: "Current password of the user",
    },
})

type OwnProps = {
    userId: string
    password: string
    passwordAgain: string
    setIsSuccess: (isSuccess: boolean) => object
    setShowVerifyModal: (showVerifyModal: boolean) => object
}



const PasswordVerificationModal = (props: OwnProps & IntlProps) => {

    const [show, setShow] = useState<boolean>(true)
    const [currentPassword, setCurrentPassword] = useState<string>("")

    const handleClose = () => {
        setShow(false)
        props.setShowVerifyModal(false)
    }

    const verifyPassword = async () => {
        const payload = {
            currentPassword: currentPassword
        }

        const res = await AppContext.getApiClient().post(`/users/${props.userId}/password-token`, payload)
        if (!res.error) {
            await updatePassword(res.token)
            fetch("/password-token")
        }
    }

    const updatePassword = async (token: string) => {
        const payload = {
            password: props.password,
            passwordAgain: props.passwordAgain
        }

        const res = await AppContext.getApiClient().patch(`/users/${props.userId}?passwordToken=${token}`, payload)
        if (!res.error) {
            props.setIsSuccess(true)
            handleClose()
        }
    }

    return (<Modal show={show} size={"lg"} onHide={handleClose}>
        <Modal.Header closeButton>
            <Modal.Title>
                <FormattedMessage
                    id="user.form.edit.password_verification.header"
                    defaultMessage="Password Verification"
                />
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {AppContext.getUserLoggedIn() && !AppContext.getUserLoggedIn().attributes.superUser &&
                <Form.Group>
                    <Form.Label className="text-align-right" htmlFor="currentPassword">
                        <FormattedMessage
                            id="user.form.edit.current_password_label"
                            defaultMessage="Current Password"
                        />
                    </Form.Label>

                    <PasswordInput
                        inputName="currentPassword"
                        handleFormChange={(e) => setCurrentPassword(e.target.value)}
                        value={currentPassword}
                        placeholder={props.intl.formatMessage(messages["user.form.edit.current_password_placeholder"])}
                    />
                    <small className="form-text text-muted">
                        <FormattedMessage
                            id="user.form.edit_password_settings.current_password_description"
                            defaultMessage="Insert your current password"
                        />
                    </small>
                </Form.Group>}
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                <FormattedMessage
                    id="quote.set_user_modal.close_btn"
                    defaultMessage="Close"
                />
            </Button>
            <Button variant="primary" onClick={verifyPassword} disabled={!currentPassword}>
                <FormattedMessage
                    id="core.modal.save_changes_button_label"
                    defaultMessage="Save Changes"
                />
            </Button>
        </Modal.Footer>
    </Modal >
    )
}

export default injectIntl(PasswordVerificationModal)


// WEBPACK FOOTER //
// ./src/user/PasswordVerificationModal.tsx